module.exports = __webpack_public_path__ + "img/arch3.a68fe7fd.jpg";